<template>
  <div class="tr-step6B">
    <div class="step6B__highlight-card">
      <div class="highlight-header">HIGHLIGHTS</div>
      <HighlightWindow6B />
      <HighlightVenti6B />
    </div>
    <div class="tr-step6B__card">
      <div class="tr-step6B__mainHead">STEP:6(B) RETV Calculation</div>
      <div class="tr-step6B__subHead">Calculation of Term - II (Glass/ Non-Opaque)</div>

      <div>
        <v-expansion-panels focusable>
          <v-expansion-panel v-for="(item, i) in step6B" :key="i" :style="{ margin: '4px' }">
            <v-expansion-panel-header>
              <div class="accordian__header--6B">
                <v-icon left>{{ item.icon }}</v-icon>
                {{ item.name }}
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="step6B__accordian-fields-wrap">
                <div class="step6B__accordian-fields-row">
                  <!--Wall Surface Area Table -->
                  <div v-if="item.name === 'Windows'">
                    <RetvWindowTable6B />
                  </div>
                  <div v-else-if="item.name === 'Ventilators'">
                    <RetvVentilatorTable6B />
                  </div>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
      <hr />
      <div class="step6B__summary">
        <div class="summary-head">Summary:</div>
        <div class="summary-block__wrap">
          <v-alert text dense color="teal" border="left">
            <div class="summary-field__row--6B" style="margin-bottom: 8px" :style="{ padding: 4 + 'px', 'padding-right': 18 + 'px', 'padding-left': 18 + 'px', 'margin-top': 4 + 'px' }">
              <div class="sumarry-field__label">
                <v-icon color="teal">mdi-sigma</v-icon>
                Term-II total:
              </div>
              <div class="summary-field__value">{{ calcTotalTerm2 }}</div>
            </div>
          </v-alert>
        </div>
      </div>
      <div class="step6B__next-back-row">
        <v-btn color="blue-grey" class="ma-2 white--text" @click="$router.push({ name: 'Retv6A' })"><v-icon left> mdi-arrow-left </v-icon> Back </v-btn>
        <v-btn color="blue-grey" class="ma-2 white--text" @click="$router.push({ name: 'Retv6C' })">Next <v-icon right> mdi-arrow-right </v-icon> </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import RetvWindowTable6B from '../tables/retv6B/RetvWindowTable6B.vue';
import RetvVentilatorTable6B from '../tables/retv6B/RetvVentilatorTable6B.vue';
import HighlightWindow6B from '../highlights/HighlightWindow6B.vue';
import HighlightVenti6B from '../highlights/HighlightVenti6B.vue';

export default {
  components: {
    RetvWindowTable6B,
    RetvVentilatorTable6B,
    HighlightWindow6B,
    HighlightVenti6B,
  },
  data() {
    return {
      step6B: [
        { name: 'Windows', icon: 'mdi-window-closed-variant' },
        { name: 'Ventilators', icon: 'mdi-hvac' },
      ],
    };
  },
  computed: {
    schema: {
      get: function() {
        return this.$store.state.schema;
      },
      set: function(newSchema) {
        this.$store.dispatch('setSchema', newSchema);
      },
    },
    step3C: {
      get: function() {
        return this.$store.state.schema.inputs.step3C;
      },
      set: function(step3B) {
        this.$store.dispatch('setStep3C', step3C);
      },
    },
    retv6B: {
      get: function() {
        return this.$store.state.schema.inputs.retv6B;
      },
      set: function(retv6B) {
        this.$store.dispatch('setRetv6B', retv6B);
      },
    },

    calcTotalTerm2() {
      let term2Total = 0;
      term2Total = +this.retv6B.summary_retv6B.total_abc_non_opaque_window + +this.step3C.summary_ventilator_openable.total_abc_ventilator;
      this.retv6B.summary_retv6B.term_2_total = +term2Total.toFixed(2);
      console.log('Term 2 Total', this.retv6B.summary_retv6B.term_2_total);
      return this.retv6B.summary_retv6B.term_2_total;
    },
  },
};
</script>

<style lang="scss">
.tr-step6B {
  padding: 22px;
  width: 100%;
  height: 100%;
}
.step6B__highlight-card {
  background-color: #fff;
  margin: 44px 0px;
  // padding: 38px;
  .highlight-header {
    background-color: #5a6978;

    padding: 8px 24px;
    color: #fff;
    font-size: 20px;
  }
}
.tr-step6B__card {
  background-color: #fff;
  padding: 28px;
  // width: 80%;
  margin: 44px 0px;
}
.tr-step6B__mainHead {
  margin: 0px 0px 8px 0;
  font-size: 28px;
  color: #343f4b;
  text-align: center;
}
.tr-step6B__subHead {
  margin: 0px 0px 18px 0;
  font-size: 20px;
  color: #343f4b;
  text-align: center;
}

.accordian__header--6B {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.step6B__summary {
  margin-top: 12px;
  .summary-head {
    font-size: 18px;
    color: #343f4b;
    font-weight: 800;
  }
}
.summary-block__wrap {
  display: flex;
  flex-direction: column;
  .summary-field__row--6B {
    display: flex;
    justify-content: space-between;
  }
  .summary-field__label {
    font-size: 12px;
    color: #343f4b;
  }
}
.step6B__next-back-row {
  padding: 16px 0px 0px 0px;
  display: flex;
  justify-content: space-between;
}
</style>
